var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"ripple",staticStyle:{"width":"100vw","height":"50vw"}})
}
var staticRenderFns = []

export { render, staticRenderFns }